{
  "common": {
    "px": "px",
    "px_uppercase": "PX",
    "seconds": "sekunder",
    "other": "-- Annan --",
    "customFieldExistsError": "Anpassad Fält med det här namnet finns redan",
    "uniqueKeyNotUniqueError": "Denna Nyckel är inte unik",
    "save": "Spara",
    "saving": "Sparar",
    "typeAnOption": "Ange ett alternativ",
    "unsaved": "Osparad",
    "noSubmissionsFound": "Inga inlämningar hittades",
    "sortBy": "Sortera efter",
    "clearAll": "Rensa alla",
    "submitSurvey": "Skicka in undersökningen",
    "select": "Välj",
    "data"  : "data",
    "disqualifyAfterSubmitLower": "Diskvalificera efter inlämning",
    "errorRetryAgain": "Fel, försök igen",
    "bubbleRadioStyleImageAlt": "Bubble-stil för alternativknapp",
    "standardRadioStyleImageAlt": "Standardstil för alternativknapp",
    "recurringFrequency": {
      "once": "En gång",
      "daily": "Dagligen",
      "weekly": "Varje vecka",
      "monthly": "Varje månad",
      "yearly": "Varje år"
    },
    "yes": "Ja",
    "no": "Nej",
    "updated": "Uppdaterad",
    "new": "Ny",
    "title": "Titel",
    "openSettings": "Öppna inställningar",
    "cloneField": "Klona fält",
    "removeField": "Ta bort fält",
    "description": "Beskrivning",
    "cannotAddThisField": "Du kan inte lägga till det här fältet",
    "overallOnly": "Endast övergripande",
    "nextSlideDefault": "Nästa bild (Standard)",
    "nextQuestion": "Nästa fråga",
    "searchAddress": "Sök efter adress",
    "recurringDonation": "Återkommande donation",
    "recurringDonationDay": "Återkommande donation 1 dag",
    "recurringDonationWeek": "Återkommande donation 1 gång per vecka",
    "recurringDonationMonth": "Återkommande donation 1 månad",
    "recurringDonationYear": "Återkommande donation 1 år",
    "integrate": "Integrera",
    "preview": "Förhandsgranska",
    "back": "Tillbaka",
    "alert": "Avisering",
    "proceed": "Fortsätt",
    "confirm": "Bekräfta",
    "cancel": "Avbryt",
    "delete": "Radera",
    "embed": "Inbäddad",
    "link": "Länk",
    "linkModal": {
      "title": "Infoga länk",
      "urlLabel": "URL",
      "urlPlaceholder": "https://www.exempel.com",
      "invalidUrl": "URL:en är ogiltig"
    },
    "iframeEmbed": "Iframe-inbäddning",
    "styles": "Stilar",
    "options": "Alternativ",
    "quickAdd": "Snabbtillägg",
    "customFields": "Anpassade fält",
    "addObjectFields": "Lägg till objektfält",
    "personalInfo": "Personuppgifter",
    "contactInfo": "Kontaktuppgifter",
    "submit": "Skicka",
    "address": "Adress",
    "customized": "Anpassad",
    "layout": "Layout",
    "showLabel": "Visa etikett",
    "showImage" : "Visa bild",
    "imageLayout" : "Bild Innehållsjustering",
    "imageLayoutSettings" : "Bild Innehållsjustering Config",
    "imageLayoutMode" : "Bild Innehållsjustering Läge",
    "surveyDefault" : "Undersökning Standard",
    "independent" : "Självständig",
    "image" : "Bild",
    "desktop" : "Dator",
    "mobile" : "Mobil",
    "desktopImage" : "Dator Bild",
    "mobileImage" : "Mobil Bild",
    "uploaded" : "Uppladdat",
    "changeImage" : "Ändra bild",
    "uploadImage" : "Ladda upp foto",
    "remove" : "Ta bort",
    "background": "Bakgrund",
    "buttonBackground": "Knapp Bakgrund",
    "fontColour": "Typsnitt",
    "textFontColour": "Teckenfärg för text",
    "subTextFontColour": "Teckenfärg för undertext",
    "selectThemes": "Välj Tema",
    "selectOne": "Välj en",
    "enableIcon": "Aktivera ikonen",
    "iconType": "Typ av ikon",
    "iconPlacement": "Ikonplacering",
    "filled": "Ifylld",
    "textOnly": "Endast Brödtext",
    "border": "Kantlinje",
    "borderType": "Kantlinjetyp",
    "cornerRadius": "Hörnradie",
    "width": "Bredd",
    "padding": "Utfyllnad",
    "top": "Toppen",
    "bottom": "Botten",
    "left": "Vänster",
    "right": "Höger",
    "center": "Centrera",
    "default": "Standard",
    "formDefault": "Standardformulär",
    "shadow": "Skugga",
    "color": "Färg",
    "horizontal": "Horisontell",
    "vertical": "Vertikal",
    "blur": "Oskärpa",
    "spread": "Storlek",
    "fieldStyle": "Fältstil",
    "fontColor": "Typsnittsfärg",
    "inputTextFillColor": "Fyllnadsfärg för inmatningstext",
    "inputTextColor": "Textfärg för inmatning",
    "primaryColor": "Primärfärg",
    "primaryColorTooltip": "Kontrollerar Färg för hovringsläge och Dynamisk Land.",
    "inputTextColorTooltip": "Kontrollerar Färg av SMS:a som skrivs in i feedback Fält.",
    "mapPrimaryColorToButtonColor": "Mappa PRIMÄR Färg till Knapp Färg",
    "label": "Etikett",
    "fontFamily": "Typsnittsfamilj",
    "size": "Storlek",
    "weight": "Tjocklek",
    "fontWeightTooltip": "Tillämpligt för eventuella stycken",
    "fontWeightOptions": {
      "thin": "100 - Tunn",
      "extraLight": "200 – Extra Light",
      "light": "300 - Light",
      "normal": "400 – Normal",
      "medium": "500 - Medium",
      "semiBold": "600 – Halvfet",
      "bold": "700 – Fet"
    },
    "placeholder" : "Platshållare",
    "customCSS" : "Anpassad CSS",
    "backgroundImage" : "Bakgrundsbild",
    "headerImage" : "Sidhuvudbild",
    "miscellaneous" : "Övrigt",
    "agencyBranding" : "Byråns varumärke",
    "imageUploadMessage" : "Klicka på eller dra en bild till det här området för att ladda upp",
    "backgroundImageTooltipMessage" : "Bakgrundsbilden är avsedd att täcka hela sidan och ger en visuellt tilltalande bakgrund för formuläret. För att se bakgrundsbilden klickar du på på alternativet Förhandsgranska.",
    "headerImageTooltipMessage" : "Sidhuvudbilden är utformad för att täcka hela formulärets bredd och placeras högst upp i formuläret. För att se sidhuvudbilden klickar du alternativet Förhandsgranska.",
    "onSubmit" : "Vid inlämning",
    "facebookPixelID" : "Facebook Pixel-ID",
    "facebookPixelIDMessage" : "Ignorera det här fältet om du planerar att använda formuläret/undersökningen i en tratt",
    "facebookPixelEvents" : "Facebook Pixel-händelser",
    "onpageView" : "Vid sidvisning",
    "stickyContact" : "Fäst kontakt",
    "stickyContactMessage" : "Kommer ihåg och fyller automatiskt i kontaktuppgifter när användaren använder samma enhet och webbläsare.",
    "fieldDescription" : "Fältbeskrivning",
    "fieldTitle" : "Fälttitel",
    "queryKey" : "Frågenyckel",
    "querykeyTooltipMessage" : "Frågenyckeln som kan användas som URL-parameter för att fylla i det här fältet",
    "required" : "Krävs",
    "hidden" : "Dold",
    "hiddenValue" : "Dolt värde",
    "enableCountryPicker" : "Aktivera landsväljare",
    "altText" : "Alt-text",
    "optionImageAlt" : "Option image",
    "bannerAlt" : "banner",
    "avatarAlt" : "Avatar Name",
    "alignment" : "Orientering",
    "imageWidth" : "Bildbredd",
    "imageHeight" : "Bildhöjd",
    "logic" : "Logik",
    "pleaseInput" : "Ange",
    "editHTML" : "Redigera HTML",
    "textStyle" : "Textformat",
    "subText" : "Undertext",
    "text" : "Text",
    "buttonStyle" : "Knappstil",
    "fullWidth" : "Full bredd",
    "htmlMessage" : "Anpassad HTML anges här",
    "htmlEditorHeader" : "ANPASSAD JAVASCRIPT / HTML",
    "htmlEditorBodyMessage" : "Lägg till din kod här",
    "scriptAdded" : "Script Added!",
    "sourceAdded" : "Source Added!",
    "yesSave" : "Ja, spara",
    "cancelKeep" : "Avbryt, behåll",
    "done" : "Klar",
    "addElement" : "Lägg till element",
    "addUrlLike" : "Inkludera giltiga URL:er såsom",
    "doNotAddRelativePath" : "Lägg inte till relativa sökvägar som",
    "or" : "eller",
    "addCustomFields" : "Lägg till anpassade fält",
    "customFieldSearch" : "Sök efter namn",
    "enterSourceValue" : "Ange källvärde",
    "shortLabel" : "Kort etikett",
    "shortLabelPlaceholder" : "Typsnitt a Kort etikett",
    "labelPlaceholder" : "Typ en etikett",
    "fileUploadPlaceholder" : "Ladda upp a Fil",
    "imagePlaceholder" : "Image",
    "fillValuesPlaceholder" : "Fyll i värden",
    "customCSSTooltip" : "Anpassad CSS har företräde framför formulärformatering och teman och kan ha en inverkan på temats stil.",
    "fontFamilyTooltip" : "Byggverktyget stöder alla typer av typsnitt om du inte kan se det i listan. Sök i rullgardinsmenyn",
    "useGDPRCompliantFont" : "Använd GDPR-kompatibelt typsnitt",
    "enableTimezone" : "Aktivera tidszon",
    "inputStyle" : "Inmatningsstil",
    "conditionalLogicAlertOnSubmit" : "Villkorlig logik kommer att ha företräde framför meddelandet/omdirigeringen här",
    "conditionalLogicAlertOnShowHide" : "Villkorlig logik kommer att ha företräde framför de dolda inställningarna här",
    "placeholderFacebookPixelIdInput" : "Ange Facebook Pixel-ID",
    "doNotShowMessage" : "Visa inte igen",
    "creatingForm" : "Skapade din Formulär ...",
    "creatingSurvey" : "Skapade din Undersökning...",
    "creatingQuiz" : "Skapade ditt quiz ...",
    "errorCreatingForm" : "Där var ett fel skapat din Formulär. Försök igen.",
    "errorCreatingSurvey" : "Där blev det ett fel skapade din Undersökning. Försök igen.",
    "errorCreatingQuiz" : "Där var ett fel skapade ditt quiz. Försök igen.",
    "redirectMessage" : "Du omdirigeras till:",
    "themes" : {
      "themes" : "Teman",
      "alertThemeMessage" : "Om du byter tema kommer du att förlora alla ändringar av den aktuella stilen.",
      "useTheme" : "Använd tema",
      "removeTheme" : "Ta bort tema"
    },
    "box" : "Ruta",
    "line" : "Rad",
    "message" : "Meddelande",
    "openUrl" : "Omdirigera till URL",
    "borderTypeList" : {
      "dotted" : "Prickad",
      "dashed" : "Streckad",
      "solid" : "Helfärgad",
      "none" : "Ingen"
    },
    "button" : "Knapp",
    "emailNotification" : "E-postavisering",
    "emailNotificationSubheader" : "Få ett e-postmeddelande när någon fyller i ditt formulär",
    "subject" : "Ämne",
    "emailTo" : "E-post (till)",
    "senderName" : "Avsändarens namn",
    "senderNameWarning" : "Ditt (underkontonamn) läggs till om det lämnas tomt",
    "emailError" : "Minst en e-postadress krävs",
    "emailTooltip" : "Den första e-postadressen är avsedd för fältet ”Till”. Eventuella efterföljande e-postadresser kommer att inkluderas i fältet ”CC”.",
    "clear" : "Rensa",
    "filter" : "Filter",
    "noResults" : "Inga resultat",
    "search" : "Sök",
    "showNotificationsSettings" : "Visa aviseringsinställningar",
    "emailServicePaid" : "Den här funktionen är en betald tjänst och kommer att medföra avgifter baserat på din användning.",
    "integration" : "Integration",
    "validation" : {
      "fieldRequired" : "Fält är Krävs",
      "maxLengthExceeded" : "Max längd har överskridits ({max} Tecken)"
    },
    "securityValidation": {
      "title":"Security issues detected. The following are not allowed:",
      "cookieAccess": "Cookie access detected (document.cookie). This is not allowed for security reasons.",
      "storageAccess": "localStorage.getItem() - reading from localStorage is not allowed.",
      "evalUsage": "Use of eval() is not allowed as it can execute arbitrary code.",
      "dynamicFunction": "Dynamic function creation (new Function) is not allowed for security reasons.",
      "stringExecution": "Passing strings to setTimeout/setInterval is not allowed as it can execute arbitrary code. Use function references instead."
    },
    "products": {
      "subscriptionBadge": "Abonnemang",
      "trialBadge": "{days} dagars gratis provperiod",
      "setupFee": "Engångsavgift för konfiguration",
      "quantity": "Antal",
      "productImageAlt": "Produktbild",
      "bumpIconAlt": "Bump-ikon"
    },
    "payment" : {
      "payments" : "Betalningar",
      "connected" : "Ansluten",
      "connect" : "Anslut",
      "liveModeOn" : "Live-läge",
      "status" : "Status",
      "test" : "Test",
      "live" : "Live",
      "paymentFields" : "Betalningsfält",
      "suggestAnAmount" : "Föreslå ett belopp",
      "recurringPayments" : "Återkommande betalningar",
      "selectCurrency" : "Välj valuta",
      "tagActiveBGColor" : "Färg på aktiv tagg",
      "includeOtherAmount" : "Inkludera annat belopp",
      "footerInfo" : "Sidfotsinfo",
      "paymentType" : "Betalningstyp",
      "sellProducts" : "Sälj produkter",
      "customAmount" : "Anpassat belopp",
      "collectPayment" : "Ta ut betalning",
      "generalSettings" : "Allmänna fält",
      "securePayments" : "*100 % Lås & säkra betalningar*",
      "error" : {
        "addMainProductFirst" : "Lägg till en PRIMÄR Produkt först",
        "priceNotFoundForBumpProduct" : "Pris hittades inte för Tilläggsprodukt",
        "productAlreadyAdded" : "Produkt har redan lagts till"
      },
      "product" : {
        "addProduct" : "Lägg till produkt",
        "productSettings" : "Produktinställningar",
        "bumpTag" : "Ytterligare val",
        "settingsAria" : "Produktinställningar",
        "deleteAria" : "Radera produkt",
        "selectProduct" : "Välj produkt",
        "editThisProduct" : "För att redigera produkten",
        "clickHere" : "Klicka här",
        "show" : "Visa",
        "description" : "Beskrivning",
        "image" : "Bild",
        "layoutSettings" : "Layoutinställningar",
        "singleColumn" : "En kolumn",
        "twoColumn" : "Två kolumner",
        "threeColumn" : "Tre kolumner",
        "maxProductError" : "Max 20 produkter är tillåtna i ett formulär",
        "productSelectPlaceholder" : "Välj en produkt",
        "orderConfirmation" : "Beställningsbekräftelse",
        "orderConfirmationWarning" : "Sidan med beställningsbekräftelsen visas när betalningen har genomförts",
        "quantity" : "Antal",
        "createProduct" : "Så här skapar du en produkt",
        "noProductsAdded" : "Inga produkter har lagts till än",
        "productsWillShowHere" : "När Du Inkludera produkter kommer de Visa upp Höger här",
        "chooseProductType" : "Välj Produkt Typ",
        "mainProduct" : "PRIMÄR Produkt"
      },
      "bumProduct" : {
        "price" : "Pris",
        "variant" : "Variant",
        "headline" : "Rubrik",
        "otoHeadline" : "OTO Rubrik",
        "otoText" : "OTO Brödtext",
        "enableImage" : "Aktivera Bild",
        "imageMessage" : "Vi tar Standard Produkt Bild",
        "orUploadADifferentImage" : "Eller Ladda upp en annan Bild",
        "bumpProducts" : "Bump-produkter",
        "bumpProduct" : "Tilläggsprodukt",
        "enableBump" : "Aktivera Bump",
        "orderBumpStyle" : "Beställningstillägg Stil",
        "classic" : "Klassisk",
        "modern" : "Modernt",
        "icon" : "Ikon",
        "bumpTemplate" : "Välj Mall",
        "highlightText" : "Markera Brödtext",
        "showPrice" : "Visa Pris",
        "bumpPriceColor" : "Högre Pris",
        "bumpIconColor" : "Bump Ikon",
        "bumpBackgroundColor" : "Bump Bakgrund",
        "highlightTextColor" : "Markera Brödtext",
        "headlineColor" : "Rubrik",
        "otoHeadlineColor" : "OTO Rubrik",
        "otoTextColor" : "OTO Brödtext",
        "bumpBorderColor" : "Bump Kantlinje",
        "priceRequired" : "Pris är Krävs",
        "headlineRequired" : "Rubrik är Krävs",
        "otoHeadlineRequired" : "OTO-rubrik krävs",
        "otoTextRequired" : "OTO-text krävs",
        "bumpProductTooltip" : "Ett Liten Tillägg erbjöds under Kassa till Multiplicera Sortera Värde. Kunder kan Inkludera det med en Individ-klick.",
        "templateOne" : "Mall 1",
        "templateTwo" : "Mall 2",
        "templateThree" : "Mall 3",
        "animationIcon" : {
          "none" : "Ingen",
          "arrow" : "Pil",
          "fire" : "Brand",
          "plus" : "Plus",
          "giftBox" : "Ruta",
          "timer" : "Nedräkning",
          "cracker" : "Knackare",
          "snack" : "Mellanmål",
          "partyBalloon" : "Festballong",
          "flash" : "Blixt",
          "money" : "Valuta",
          "spaceShuttle" : "Yta"
        }
      },
      "coupons" : {
        "coupons" : "Kuponger",
        "enableCoupon" : "Aktivera kupong",
        "couponAlignment" : "Kupongjustering",
        "left" : "Vänster",
        "right" : "Höger",
        "fullWidth" : "Full bredd",
        "tooltipMessage" : "Ställ in positionen för kuponginmatning från typerna nedan"
      }
    },
    "addressSettings" : {
      "autoComplete" : "Adress fylls i automatiskt",
      "addressfields" : "Adressfält",
      "placeholderSearch" : "Sök efter en adress",
      "autoCompleteTooltip" : "Gör det möjligt söka efter och automatiskt fylla i adress.",
      "streetAddress" : "Adress",
      "autoCompleteAddressTitle" : "Auto Slutför Adress",
      "newBadge" : "Ny",
      "defaultLabel" : "Adress",
      "searchPlaceholder" : "Sök adress",
      "mandataorySearch" : {
        "title" : "Krävs till Välj adress in Sök Bar",
        "primaryText" : "Automatisk komplettering endast för Adress",
        "secondaryText" : "När Aktiverad, När a Användare interagerar med Adressfältet, Sedan måste de välja en giltig adress till Fortsätt.",
        "secondaryText1" : "När Inaktiverad Sedan kan de Fortsätt utan att välja en adress in fältet Sök."
      }
    },
    "autoResponder" : "Autosvar",
    "autoResponderSubheader" : "Skicka ett automatiskt e-postmeddelande till personen som skickar in formuläret (e-postmeddelandet innehåller en kopia av den information som de angav i formuläret)",
    "replyToEmail" : "Svarsmejl",
    "open" : "Öppen",
    "won" : "Vunnen",
    "lost" : "Förlorad",
    "abandon" : "Överge",
    "selectAPipeline" : "Välj en pipeline",
    "stage" : "Stadium",
    "status" : "Status",
    "opportunityValue" : "Möjlighetens värde",
    "createNewPipeline" : "Skapa ny pipeline",
    "editOpportunitySettings" : "Redigera möjlighetsinställningar",
    "contact" : "Kontakt",
    "opportunity" : "Möjlighet",
    "business" : "Företag",
    "add" : "Lägg till",
    "more" : "Mer",
    "opportunityHeading" : "Var vill du att din möjlighet ska uppdateras?",
    "date" : {
      "dateSettings" : "Datuminställningar",
      "dateFormat" : "Datumformat",
      "dateSeparator" : "Datumavdelare",
      "dateFormatTooltipMessage" : "Välj ett datumformat. D står för dag, M för månader och Y för år",
      "dateSeparatorTooltipMessage" : "Välj en avdelare som separerar dag, månad och år i det format som valts i Datumformat",
      "disablePicker" : "Inaktivera väljare"
    },
    "restoreVersion" : "Återställ version",
    "versionHistory" : "Versionshistorik",
    "errorMessage" : "Fel, försök igen",
    "version" : "Version:",
    "currentVersion" : "Nuvarande version",
    "messageStyling" : "Meddelandeformat",
    "validateEmailHeader" : "Validera e-post",
    "validateEmailDescription" : "Knappen blir synlig när användaren anger sin e-postadress. Den här funktionen är utformad för att hjälpa dig att generera potentiella kunder av hög kvalitet.",
    "verifyEmail" : "Verifiera e-postadress",
    "validatePhoneHeader" : "Validera telefon",
    "validatePhoneDescription" : "Knappen blir synlig när användaren anger sitt telefonnummer. Den här funktionen är utformad för att hjälpa dig att generera potentiella kunder av hög kvalitet.",
    "verifyPhone" : "Verifiera telefonnummer",
    "validatePhoneWarning" : "För att aktivera SMS OTP-verifiering behöver du se till att ditt telefonnummer är inställt i platsinställningarna",
    "addAnotherTnc" : "Lägg till ytterligare regler och villkor",
    "tnc1" : "T & C 1",
    "tnc2" : "T & C 2",
    "deleteCaps" : "DELETE",
    "deleteConfirmation" : "Skriv DELETE för att bekräfta",
    "marginPadding" : "Marginal och utfyllnad",
    "style" : {
      "formLayoutType" : "Formulärtyp",
      "layoutType" : "Typ av layout",
      "surveyType" : "Undersökningstyp",
      "oneColumn" : "En kolumn",
      "twoColumn" : "Två kolumner",
      "singleLine" : "En rad",
      "fieldWidth" : "Fältbredd",
      "labelAlignment" : {
        "labelAlignment" : "Etikettjustering",
        "labelWidth" : "Etikettbredd"
      },
      "fieldSpacing" : "Fältavstånd",
      "imageFieldSpacing" : "Bild- och fältavstånd",
      "imageCornerRadius" : "Hörnradie för bild",
      "color" : "färg",
      "fontColor" : "Typsnittsfärg",
      "inputBackgroundColor" : "Bakgrundsfärg för inmatning",
      "inputBorder" : "Feedback Kantlinje",
      "layout" : "Layout",
      "colorsAndBackground" : "Färger och bakgrund",
      "imageLayout" : {
        "imageLayout" : "Bildlayout",
        "showImage" : "Visa bild",
        "image" : "Bild",
        "desktop" : {
          "topFixed" : "Högsta Fixerad",
          "leftCenter" : "Vänster Centrera",
          "rightCenter" : "Höger Centrera",
          "leftFixed" : "Fast till vänster",
          "rightFixed" : "Höger Fixerad",
          "background" : "Bakgrund"
        },
        "mobile" : {
          "header" : "Rubrik",
          "background" : "Bakgrund"
        }
      },
      "focusPoint" : {
        "title" : "Fokuspunkt",
        "reset" : "Återställ",
        "noImage" : "Ingen bild har laddats upp"
      },
      "advanceSettings" : "Avancerade Inställningar",
      "inputField" : "Inmatningsfält",
      "borderWidth" : "Kantlinjebredd",
      "borderColor" : "Kantlinjefärg",
      "borderStyle" : "Kantlinjestil",
      "fontSize" : "Teckenstorlek",
      "fontWeight" : "Typsnittstjocklek",
      "labelColor" : "Etikettfärg",
      "placeholderColor" : "Platshållarfärg",
      "shortLabelColor" : "Färg på kort etikett"
    },
    "replyToTooltip" : "Anpassa standardsvarsmejlen genom att använda {'{'}{'{'}contact.email{'}'}{'}'} för att aktivera svar till kontakten som skickar formuläret.",
    "content" : "Innehåll",
    "calculations" : "Beräkningar",
    "uploadOptions" : "Uppladdningsalternativ",
    "opportunitySettingsWarning" : "Ange möjlighetsinställningar genom att klicka på knappen Redigera möjlighetsinställningar.",
    "startValue" : "Startvärde",
    "endValue" : "Slut",
    "today" : "Idag",
    "thisWeek" : "Den här veckan",
    "last7Days" : "Senaste 7 dagarna",
    "thisMonth" : "Den här månaden",
    "last30Days" : "Senaste 30 dagarna",
    "question" : "Fråga",
    "createContactOnPartialSubmission" : "Skapa kontakt vid partiell inlämning",
    "howItWorks" : "Hur fungerar det?",
    "createContactOnPartialSubmissionDescription" : "Slutför bilden och klicka på ”Nästa”. En ny kontakt skapas och lagras automatiskt.",
    "swapWarningMessageSurvey" : "Om alternativ redigeras eller byts ut påverkas det anpassade fältet på alla platser där fältet används. Det kan också återställa villkorlig logik. ",
    "swapWarningMessageForm" : "Om alternativ redigeras eller byts ut påverkas det anpassade fältet på alla platser där fältet används. ",
    "migrationWarningMessage" : "Funktionen har migrerats till villkorlig logik för undersökningar.",
    "optionLabel" : "Alternativetikett",
    "calculationValue" : "Beräkningsvärde",
    "addOption" : "Lägg till alternativ",
    "enableCalculations" : "Aktivera beräkningar",
    "allowOtherOption" : "Tillåt annat alternativ",
    "productSelectionSubtext" : "Aktivera Individ Eller urval av flera produkter",
    "multi" : "Flera",
    "single" : "Individ",
    "productSelectionHeading" : "Produkt",
    "spreadToColumns" : "Sprid ut till kolumner",
    "columns" : "Kolumner",
    "customstyle" : "Stil",
    "standard" : "Standard",
    "bubble" : "Bubbla",
    "integratePopup" : {
      "title" : "Integrera formulär",
      "embedCode" : "Bädda in kod",
      "useInFunnelOrEmbedCode" : "Använd i tratt/inbäddningskod",
      "iframeEmbed" : "Inbäddad iframe",
      "layout" : {
        "title" : "Typ av inbäddningslayout",
        "description" : "Välj en layout för att bädda in i en tratt eller extern webbplats",
        "allowMinimize" : "Tillåt minimering",
        "minimizedTitlePlaceholder" : "Minimerad titel",
        "leftAlignAlt" : "Vänsterjustera",
        "rightAlignAlt" : "Högerjustera"
      },
      "triggerType" : "Utlösartyp",
      "triggers" : {
        "seconds" : "sekunder"
      },
      "activation" : {
        "title" : "Aktiveringsalternativ",
        "visit" : "besök"
      },
      "deactivation" : {
        "title" : "Inaktiveringsalternativ",
        "times" : "gånger"
      },
      "copyEmbedCode" : "Kopiera inbäddningskod",
      "copyFormLink" : "Kopiera formulärlänk",
      "openFormLink" : "Öppna formulärlänk",
      "invalidInput" : "Ogiltig inmatning!",
      "funnel" : {
        "funnel" : "Tratt",
        "chooseStep" : "Välj a Steg",
        "copyCodeAndOpenFunnel" : "Kopiera Kod och Öppna Tratt"
      },
      "share" : {
        "share" : "Dela",
        "shareViaSocials" : "Dela Via Sociala medier",
        "copyLink" : "Kopiera länk"
      },
      "email" : {
        "email" : "E-post",
        "shareViaEmail" : "Dela Via E-post",
        "emailButton" : "E-post",
        "blankTemplate" : "Tom Mall",
        "emailMarketingTemplates" : "Mallar för E-post Marknadsföring",
        "or" : "Eller",
        "chooseTemplate" : "Välj bland dina mallar",
        "continue" : "Fortsätt"
      }
    },
    "rating" : {
      "icon" : "Ikon",
      "iconAlignment" : "Ikon Orientering",
      "count" : "Antal",
      "lowestRating" : "Min Betyg",
      "highestRating" : "Max",
      "iconSelectedState" : "Ikon Markerad Delstat",
      "iconUnselectedState" : "Ikon Avmarkerat Delstat",
      "rating" : "Betyg",
      "ratingSettings" : "Betyg Inställningar",
      "calculationType" : {
        "calculationType" : "Hur man Arkivera Betyg Fält in Anpassad Fält",
        "calculationTypeTooltip" : "När Du Frekvens något 4 Från 5 stjärnor betyder det: - Absolut: 4 från 5 - Procentsats: 80 - Bråk: 0,8",
        "absolute" : "Absolut",
        "percentage" : "Procentsats",
        "fraction" : "Bråk"
      }
    },
    "desktopMode" : "Datorläge",
    "mobileMode" : "Mobilläge",
    "versions" : "Varianter",
    "advanced" : "Avancerat",
    "edit" : "Redigera",
    "settings" : "Inställningar",
    "submissions" : "Inlämningar",
    "undo" : "Ångra",
    "redo" : "Gör om",
    "customValues" : "Anpassade värden",
    "pickBgFromImage" : "Gör bakgrunden i meddelandefältet suddig. Om du väljer en bakgrundsfärg för meddelandefältet visas den ovanpå det suddiga meddelandefältet.",
    "pickBgFromImageTip" : "Väljer en Färg med hög Jämför för BG-Bilden. Meddelande: Används inte om Formulär Bakgrunden inte har någon Bild",
    "messageBackgroundBlur" : "Bakgrundsoskärpa",
    "confirmationMessage" : "Bekräftelsemeddelande",
    "deleteOption" : "Alternativ för Radera",
    "deleteConfirmationModal" : {
      "defaultDescription" : "Raderar ett alternativ kommer att påverka detta Anpassad-fält över varje Platser där fältet används. Är du säker på att du vill Radera det?",
      "validationMessage" : "Vänligen ange Radera till Spara.",
      "validationError" : "Vänligen ange Radera"
    },
    "disqualifyImmediately" : "Diskvalificera omedelbart",
    "disqualifyAfterSubmit" : "Diskvalificera efter inlämning",
    "generalSettings" : "Allmän Inställningar",
    "advancedSettings" : "Avancerade Inställningar",
    "customFieldName" : "Anpassad Bransch Namn",
    "customFieldNameTooltip" : "Denna Bransch Namn är unik per Anpassad Bransch.",
    "uniqueKey" : "Unik nyckel",
    "uniqueKeyTooltip" : "Detta Nyckel är unikt per Anpassad Bransch.",
    "selectContactAssociation" : "Klicka på relationen med Kontakter",
    "associations" : "Associationer",
    "createNewAssociation" : "Skapa ny association",
    "selectAnAssociation" : "Välj en association",
    "loadingAssociations" : "Läser in associationer...",
    "unknownAssociation" : "Okänd Förening",
    "manyToMany" : "Många till många",
    "failedToLoadAssociations" : "Misslyckades med att läsa in associationer.",
    "noAssociationsFound" : "Inga associationer hittades",
    "keepThisField" : "Behåll det här fältet",
    "association" : "Association",
    "customObject" : "Anpassat objekt",
    "customObjects" : "Anpassade objekt",
    "object" : "Objekt",
    "editAssociation" : "Redigera {objectName} association",
    "editAssociationButton" : "{edit} {objectName} {association}",
    "fields" : "Fält",
    "primaryFieldWarning" : "{fieldName} är ett PRIMÄR fält för {objectSingular} och Krävs för att skapa Eller Uppdatera en {objectSingular}.",
    "primaryFieldTitle" : "{fieldName} krävs för att skapa eller uppdatera {objectSingular} -posten.",
    "removeAllFields" : "Rensa alla {objectSingular} Fält",
    "customObjectsFallback" : "Anpassade objekt",
    "noneAssociation" : "Ingen",
    "noneAssociationDescription" : "Ingen Relation till Kontakter (inga Kontaktfält finns)",
    "survey" : {
      "layoutType" : "Undersökningstyp",
      "oneQuestionPerPage" : "En fråga i taget",
      "allQuestionsOnePage" : "Många i taget"
    },
    "quizQuestions" : "Quiz Fråga",
    "choiceElements" : "Choice Komponenter",
    "otherElements" : "Annan Komponenter",
    "listEditor" : {
      "prefillValueHeader" : "Värde för Fyll i på förhand",
      "labelPlaceholder" : "Etikett",
      "valuePlaceholder" : "Värde",
      "optionRequiredError" : "Alternativet Fält är Krävs"
    },
    "field" : "Fält",
    "scoreEditor" : {
      "addFieldPlaceholder" : "Lägg till Fält",
      "fieldLabel" : "Fält",
      "numberLabel" : "siffra"
    },
    "fileUploadEditor" : {
      "fileTypes" : "Fil",
      "all" : "varje",
      "pdf" : "PDF",
      "docxDoc" : "DOCX/DOC",
      "png" : "PNG",
      "gif" : "GIF",
      "jpgJpeg" : "JPG/JPEG",
      "xlsCsv" : "XLS/CSV"
    },
    "ok": "Ok",
    "allowMultipleFiles": "Aktivera Multiple Filer",
    "maxFileLimit": "Max Fil",
    "privacyPolicy": "Sekretesspolicy",
    "termsOfService": "Villkor för tjänsten",
    "billingFrequency": "Faktureringsfrekvens",
    "otherAmount": "Annat belopp",
    "exampleUrlPlaceholder": "https://www.exempel.com",
    "checkboxStyles": {
      "standardAlt": "Standardstil för kryssruta",
      "bubbleAlt": "Bubble-stil för kryssruta"
    },
    "previewIcons" : {
      "exportAlt" : "Exportikon",
      "shipmentAlt" : "Leveransikon",
      "resultAlt" : "Ikon för resultatsida"
    },
    "examples" : {
      "sampleUrl" : "https://exempel.com"
    },
    "showing": "Visning",
    "of": "av",
    "enterCouponCode": "Ange kupongkod",
    "apply": "Tillämpa",
    "paymentWillBeProcessed": "Betalningen kommer att behandlas så snart ni går vidare till nästa steg",
    "paymentWillBeProcessedNextSlide": "Betalningen kommer att behandlas så snart användaren går vidare till nästa bild",
    "showThisAlertToUsers": "Visa den här varningen för användarna",
    "sixteenDigitCardNumber": "16-siffrigt kortnummer",
    "mmYy": "MM/ÅÅ",
    "cvc": "CVC",
    "pleaseFillRequiredFields": "Fyll i alla obligatoriska fält!",
    "opportunitySettingsIncomplete": "Inställningarna för affärsmöjligheterna är ofullständiga",
    "opportunitySettingsIncompleteDescription": "Det här formuläret innehåller fält för affärsmöjligheter, men inställningarna för affärsmöjligheter har inte uppdaterats. Konfigurera inställningarna för affärsmöjligheter för att kunna spara formuläret.",
    "ariaAttributes": {
      "iconSearch": "Ikonsök"
    },
    "alt": {
      "standardRadioStyle": "Standardstil för alternativknapp",
      "bubbleRadioStyle": "Bubble-stil för alternativknapp"
    },
    "value": "Värde",
    "jumpTo": "Hoppa till",
    "thankYouJohnDoe": "Tack, John Doe",
    "total": "Totalt",
    "urlExamples": {
      "simple": "example.com",
      "https": "https://exempel.com",
      "withPath": "example.com/path",
      "fullPath": "https://www.example.com/path"
    }
  },
  "fields": {
    "quizQuestions": {
      "singleChoice": "Individuellt val",
      "multipleChoice": "Flervalsalternativ",
      "yesNo": "Ja / Nej",
      "shortAnswer": "Kort textsvar",
      "longAnswer": "Långt svar",
      "number": "siffra",
      "singleDropdown": "Individuell Rullgardinsmeny",
      "multiDropdown": "Flera Rullgardinsmeny"
    },
    "personal": {
      "fullName": "Fullständigt namn",
      "firstName": "Förnamn",
      "lastName": "senaste Namn",
      "dateOfBirth": "Födelsedatum",
      "phone": "Telefon",
      "email": "E-postadress"
    },
    "submit" : {
      "button" : "Knapp"
    },
    "integration" : {
      "sellProducts" : "Sälj produkter",
      "collectPayment" : "Ta emot Utbetalning"
    },
    "address": {
      "address": "Adress",
      "streetAddress": "Adress",
      "city": "Stad",
      "state": "Delstat",
      "country": "Land",
      "postalCode": "Postnummer",
      "organization": "Grupp",
      "website": "Webbplats",
      "websitePlaceholder": "URL går här"
    },
    "text" : {
      "singleLine" : "Enskild Linje",
      "multiLine" : "Flera Linje",
      "textBoxList" : "SMS:a Fyrkant Lista"
    },
    "choiceElements" : {
      "singleDropdown" : "Individuell Rullgardinsmeny",
      "multiDropdown" : "Flera Rullgardinsmeny",
      "checkbox" : "Kryssruta",
      "radio" : "Alternativknapp"
    },
    "customized" : {
      "text" : "Klicka för att redigera den här texten",
      "html" : "Html",
      "htmlPlaceholder" : "Den Anpassad HTML-koden finns här",
      "captcha" : "Captcha",
      "source" : "Källa",
      "termsAndConditions" : "T & C",
      "termsAndConditionsPlaceholder" : "Jag godkänner villkoren Utfärdade Via företaget. Via att uppge mitt telefonnummer godkänner jag Ärv SMS:a-meddelanden Från företaget.",
      "score" : "Poäng"
    },
    "other" : {
      "image" : "Bild",
      "fileUpload" : "Fil Ladda upp",
      "monetary" : "Monetärt",
      "number" : "siffra",
      "datePicker" : "Datum",
      "signature" : "Signatur"
    },
    "customstyle" : "Stil",
    "standard" : "Standard",
    "bubble" : "Bubbla"
  },
  "survey": {
    "typeOfBuilder": "Undersökning",
    "survyeStyle": "Undersökningsstil",
    "surveyName": "Undersökningsnamn",
    "surveyElement": "Undersökningselement",
    "addSurveyElement": "Lägg till undersökningselement",
    "cloneSlide": "Klona Bild",
    "unsavedAlertMessage": "Undersökningen har arbete som inte har sparats. Är du säker på att du vill lämna och kasta allt osparat arbete?",
    "thirdPartyScriptAlertMessage": "Tredjepartsskript inuti HTML-blocket kan ge effektiva funktioner men de medför också risker för integritet, säkerhet, prestanda och sidbeteende. Därför rekommenderar vi att du granskar innehållet i det här skriptet innan du sparar det i undersökningen.",
    "integrateHeader": "Integrera undersökning",
    "integrateSubHeader": "Använd följande alternativ för att integrera din anpassade undersökning på en webbplats",
    "integrateCopyLinkMessage": "Kopiera länken nedan och dela den enkelt var du vill.",
    "onSurveySubmission": "Vid undersökningsinlämning",
    "surveySettings": "Undersökningsinställningar",
    "oneQuestionAtTime": "En fråga i taget",
    "backButton": "Tillbaka-knapp",
    "backButtonTooltipMessage": "Tillbaka-knappen hjälper användarna att gå till föregående bild",
    "disableAutoNavigation": "Inaktivera automatisk navigering",
    "disableAutoNavigationTooltipMessage": "Navigerar automatiskt till Nästa Skjut Efter a Användare svarar.",
    "autoNavigation": "Auto navigering",
    "autoNavigationTooltipMessage": "Navigerar automatiskt till Nästa Skjut Efter a Användare svarar.",
    "progressBar": "Förloppsfält",
    "progressBarTooltipMessage": "Om du stänger av detta tas förloppsfältet bort från undersökningen",
    "disableAnimation": "Inaktivera animation",
    "disableAnimationTooltipMessage": "Om du aktiverar det här inaktiveras animationen för bildövergångar",
    "scrollToTop": "Skrolla till toppen",
    "scrollToTopTooltipMessage": "Om det är aktiverat skrollas undersökningen till toppen på nästa bild",
    "submitSurvey": "Skicka in undersökningen",
    "disqualifyImmediately": "Diskvalificera omedelbart",
    "disqualifyAfterSubmit": "Diskvalificera efter inlämning",
    "disqualifyAfterSubmitLowerCase": "Diskvalificera efter inlämning",
    "footerHTML": "HTML för sidfot",
    "footerHTMLMessage": "Du kan skriva anpassad CSS (med hjälp av stiltaggar) och HTML i samma ruta",
    "editFooter": "Redigera sidfot",
    "disqualifySettings": "Inställningar för diskvalificering",
    "disqualifyImmediatelyLabel": "Omedelbart",
    "disqualifyAfterSubmitLabel": "Efter att ha skickat in",
    "slideConflictAlertMessage": "Den här bilden innehåller flera frågor med inställd logik. Detta kan orsaka oavsiktligt beteende",
    "addSlide": "Lägg till bild",
    "settings": "Inställningar",
    "delete": "Radera",
    "slideDeleteAlertMessage": "Är du säker på att du vill ta bort den här bilden?",
    "slideDeleteBetweenAlertMessage": "Detta kommer att omorganisera de andra bilderna. Är du säker på att du vill ta bort den här bilden?",
    "slideLabel": "Bild {n}",
    "slideName": "Bildens namn",
    "slidePosition": "Bildens placering",
    "jumpTo": "Hoppa till",
    "jumpToSubText": "Hoppa till en specifik bild",
    "enableTimezoneSurvey": "Om du aktiverar det här alternativet registreras information om tidszon för den person som skickar in undersökningen",
    "footer": {
      "footer": "Sidfot",
      "enableNewFooter": "Aktivera ny sidfot",
      "stickToSurvey": " Fäst till undersökning",
      "backgroundFill": "Bakgrundsfyllnad",
      "footerHeight": "Sidfotshöjd",
      "enableProgressBar": "Aktivera förloppsindikator",
      "buttons": "Knappar",
      "button": "Knapp",
      "buttonType": "Knapptyp",
      "fillNext": "Fyll (nästa)",
      "fillPrevious": "Fyll (föregående)",
      "fillSubmit": "Fyll i (skicka)",
      "textColor": "Knapptext",
      "position": "Position",
      "previousText": "Föregående (text)",
      "nextText": "Nästa (text)",
      "submitText": "Skicka (text)",
      "fillComplete": "Fyllning vid komplett",
      "fillInactive": "Fyllning vid inaktiv",
      "footerType": "Sidfotstyp",
      "stickToCard": "Håll dig till kortet",
      "stickToPage": "Håll dig till sidan",
      "stepTextColor": "Steg Brödtext Färg",
      "progressBarFill": "Förloppsfält Fyll",
      "progressBarInactive": "Förloppsfält Inaktiv",
      "arrowFill": "Fyll med Pil",
      "submitColorMobile": "Skicka (Färg)",
      "arrowFillColor": "Pil Fyll Färg",
      "buttonTypes": {
        "textAndArrow": "Text och pil",
        "onlyText": "Bara text",
        "onlyArrow": "Endast Arrow"
      },
      "positions" : {
        "leftAndRight" : "Vänster & Höger"
      },
      "placeholders" : {
        "prev" : "Föreg.",
        "next" : "Nästa",
        "submit" : "Skicka"
      }
    },
    "surveyNotfication" : "Undersökningsavisering",
    "style" : {
      "surveyPadding" : "Undersökningsutfyllnad"
    },
    "integratePopup" : {
      "shareOrEmbed" : "Bädda in eller dela undersökning",
      "share" : {
        "openFormLink" : "Öppna Undersökning Länk"
      },
      "email" : {
        "emailSubheader" : "Skapa ett tomt E-inlägg och Inbäddad din Undersökning, Eller Välj a Mall och Inbäddad it Omedelbart."
      }
    },
    "autoResponderSubheader": "Skicka ett automatiskt e-postmeddelande till personen som skickar in undersökningen (e-postmeddelandet innehåller en kopia av den information som de angav i undersökningen)",
    "sendSubmissionsAsPdf": "Skicka inlämnad undersökning som en PDF",
    "switchToOneQuestionAtTimeOn": "Om du aktiverar ”En fråga vid ett datum” störs din Nuvarande villkorliga Logik",
    "switchToOneQuestionAtTimeOff": "Inaktivera ”En fråga vid ett datum” påverkar din villkorliga Logik Config",
    "switchToOneQuestionAtTimeOnWarning": "Vissa villkor kommer inte längre att fungera som förväntat När-frågor är Deltog one at a Datum.",
    "switchToOneQuestionAtTimeOffWarning": " Vissa villkor avsedda för individuell fråga Flöde slutar fungera som avsett.",
    "createContactOnPartialSubmissionSubText": "Skapar en kontakt när en användare klickar på ”Nästa” på en bild – även om hen inte slutför undersökningen.",
    "dragDrop": {
      "imageLabel": "Bild {n}",
      "htmlLabel": "HTML {n}",
      "defaultFolderName": "Undersökning {'|'} {name}",
      "defaultTermsHtml": "<p style=\"text-align: center\"><a target=\"_blank\" rel=\"noopener noreferrer nofollow\" href=\"https://www.example.com\">Integritetspolicy</a> | <a target=\"_blank\" rel=\"noopener noreferrer nofollow\" href=\"https://www.example.com\">Användarvillkor</a></p>",
      "smsConsent": "Jag samtycker till att ta emot SMS-aviseringar, varningar och enstaka marknadsföringsmeddelanden från företaget. Meddelandenas frekvens varierar. Meddelande- och dataavgifter kan tillkomma. Sms:a HJÄLP till (XXX) XXX-XXXX för att få hjälp. Du kan när som helst svara STOPP för att sluta prenumerera."
    }
  },
  "form" : {
    "typeOfBuilder" : "Formulär",
    "formStyle" : "Formulärstil",
    "formElement" : "Formulärelement",
    "addFormElement" : "Lägg till formulärelement",
    "addConditionalLogic" : "Lägg till villkorlig logik",
    "openConditionalLogic" : "Öppna villkorlig logik",
    "inlineForm" : "Infogat formulär",
    "formName" : "Formulärnamn",
    "fullScreenMode" : "Fullskärmsläge",
    "fullScreenModetooltip" : "Om du aktiverar det kommer formuläret att expanderas över hela behållarens bredd och sträcka sig till kanten av inbäddningsområdet samtidigt som det följer formulärets bredd.",
    "enableTimezoneForm" : "Om du aktiverar det här alternativet registreras information om tidszon för den person som skickar in formuläret",
    "formSettings" : "Formulärinställningar",
    "unsavedAlertMessage" : "Formuläret har arbete som inte har sparats. Är du säker på att du vill lämna och kasta allt osparat arbete?",
    "thirdPartyScriptAlertMessage" : "Tredjepartsskript inuti HTML-blocket kan ge effektiva funktioner men de medför också risker för integritet, säkerhet, prestanda och sidbeteende. Därför rekommenderar vi att du granskar innehållet i det här skriptet innan du sparar det i formuläret.",
    "onFormSubmission" : "Vid formulärinlämning",
    "integrateForm" : "Integrera formulär",
    "embedlayoutType" : "Inbäddad Layout Typ",
    "embedlayoutTypeSubMessage" : "Välj en layout för att bädda in i en tratt eller extern webbplats",
    "triggerType" : "Utlösartyp",
    "showOnScrolling" : "Visa vid skrollning",
    "showAfter" : "Visa efter",
    "seconds" : "sekunder",
    "alwaysShow" : "Visa alltid",
    "activationOptions" : "Aktiveringsalternativ",
    "activateOn" : "Aktivera vid",
    "visit" : "besök",
    "alwaysActivated" : "Alltid aktiverad",
    "deactivationOptions" : "Inaktiveringsalternativ",
    "deactivateAfterShowing" : "Inaktivera efter visning",
    "times" : "gånger",
    "deactiveOnceLeadCollected" : "Inaktivera när potentiell kund har registrerats",
    "neverDeactivate" : "Inaktivera aldrig",
    "copyEmbedCode" : "Kopiera inbäddningskod",
    "copyFormLink" : "Kopiera formulärlänk",
    "openFormLink" : "Öppna formulärlänk",
    "inline" : "Infogat",
    "inlineDescription" : "Ett infogat formulär visas tillsammans med innehållet på sidan som ett inbyggt element. Den ligger inte ovanpå sidan och kan inte stängas eller minimeras.",
    "inlineHoverDescription" : "Ett infogat formulär visas tillsammans med innehållet på sidan som ett inbyggt element. Den ligger inte ovanpå sidan och kan inte stängas eller minimeras.",
    "popup" : "Popup",
    "popupDescription" : "Ett popup-fönster visar formulär som ett överlägg inuti ett fönster. Det kan inte minimeras utan måste stängas.",
    "popupHoverDescription" : "Ett popup-fönster visar formulär som ett överlägg inuti ett fönster. Det kan inte minimeras utan måste stängas.",
    "politeSlideIn" : "Artigt insegel",
    "politeSlideInDescription" : "Ett artigt insegel visas längst ned på skärmen och försvinner när det stängs",
    "politeSlideInHoverDescription" : "Visas på skärmens undersida och försvinner när den stängs",
    "stickySidebar" : "Fäst sidofält",
    "stickySidebarDescription" : "Ett fäst sidofält visas på sidan av skärmen och kan minimeras till en flik som fästs vid sidan av fönstret",
    "stickySidebarHoverDescription" : "Visas på sidan av skärmen och kan minimeras till en flik som fästs vid sidan av fönstret",
    "allowMinimize" : "Tillåt minimering",
    "conditonalLogic" : {
      "conditions" : "Villkor",
      "noExistingCondition" : "Inga befintliga villkor än",
      "freeRoamMessage" : "Du kan ströva fritt utan reglerna – för tillfället i alla fall",
      "addNewCondition" : "Lägg till nytt villkor",
      "redirectToUrl" : "Omdirigera till URL",
      "displayCustomMessage" : "Visa anpassat meddelande",
      "disqualifyLead" : "Diskvalificera potentiell kund",
      "showHideFields" : "Visa/dölj fält",
      "jumpTo" : "Hoppa till",
      "redirectToUrlSubText" : "Omdirigera Användare efter inlämning",
      "displayCustomMessageSubText" : "Visa-meddelanden baserade På Användare-ingångar",
      "disqualifyLeadSubText" : "Filtrera bort poster under specifika förhållanden",
      "showHideFieldsSubText" : "Ändra Fält Synlighet dynamiskt",
      "openBelowUrl" : "Öppna nedanstående URL",
      "showCustomMessage" : "Visa anpassat meddelande",
      "alertConditionDelete" : "Är du säker på att du vill ta bort det här villkoret?",
      "deleteCondition" : "Ta bort villkor",
      "conditionExecutedMessage" : "Villkoren kommer att exekveras uppifrån och ned.",
      "allOperationOptions" : {
        "isEqualTo" : "Är lika med",
        "isNotEqualTo" : "Är inte lika med",
        "contains" : "Innehåller",
        "doesNotContain" : "Innehåller inte",
        "startsWith" : "Börjar med",
        "endsWith" : "Slutar med",
        "isEmpty" : "Är tom",
        "isFilled" : "Är fylld",
        "before" : "Före",
        "after" : "Efter",
        "greaterThan" : "Större än",
        "lessThan" : "Mindre än",
        "between" : "Mellan",
        "isChecked" : "Är markerad",
        "isNotChecked" : "Är inte kontrollerad"
      },
      "logic" : {
        "if" : "Om",
        "then" : "Gör därefter",
        "and" : "Och",
        "or" : "Eller"
      },
      "phoneAlertMessage" : "För att söka efter telefonnummer med landskod måste du inkludera symbolen ”+” i din sökfråga.",
      "deleteAlertMessage" : "Är du säker på att du vill ta bort det här fältet? Villkoret för fältet kommer också att tas bort.",
      "deleteField" : "Ta bort fält",
      "jumpToDescription" : "Hoppa till en specifik bild när villkoren är uppfyllda",
      "cycleError" : "Det går inte att spara. Loop upptäckt mellan {a} och {b}",
      "jumpToSlide" : "Hoppa till bild",
      "submitSurvey" : "Spara undersökning",
      "pageTitle" : "P{index} - {title}",
      "selectSlideToJumpTo" : "Välj Skjut att hoppa Från",
      "selectedSlide" : "Vald bild",
      "typeValueHere" : "Var god ange ett Värde här",
      "field" : "Fält",
      "slide" : "Bild",
      "selectFieldOrSlide" : "Välj Bransch eller Skjut",
      "selectFieldState" : "Välj fältstatus",
      "selectField" : "Välj fält",
      "selectOption" : "Välj alternativ",
      "jumpToTarget" : "Hoppa till",
      "jumpToQuestion" : "Hoppa till frågan",
      "chooseQuestion" : "Välj fråga",
      "includeStart" : "Inkludera start",
      "includeEnd" : "Inkludera slut",
      "includeValue" : "Inkludera {value}",
      "hideField" : "Dölj fält",
      "hideFields" : "Dölj fält",
      "showField" : "Visa fält",
      "showFields" : "Visa fält",
      "additionalRulesPrefix" : "...och",
      "additionalRulesSuffix" : "andra {ifLabel}-regler …",
      "shownTargetsWithMore" : "{shown}, +{count} till",
      "noConditionsAlt" : "Inga villkor än",
      "outcomeLabels" : {
        "show" : "Visa",
        "jumpTo" : "Hoppa till"
      }
    },
    "minimizedTitlePlaceholder": "Minimerad titel",
    "dragYourElementFromLeft": "Dra dina element hit från vänster",
    "formNotification": "Formuläravisering",
    "sendSubmissionsAsPdf": "Skicka formulärinlämning som en PDF",
    "style": {
      "formPadding": "Formutfyllnad"
    },
    "integratePopup" : {
      "shareOrEmbed" : "Bädda in eller dela formuläret",
      "share" : {
        "openFormLink" : "Öppna Formulär länk"
      },
      "email" : {
        "emailSubheader" : "Skapa ett tomt E-inlägg och Inbäddad din Formulär, Eller Välj a Mall och Inbäddad it Omedelbart."
      }
    },
    "choosePosition": "Välj Status",
    "testBuild": "Testversion"
  },
  "quiz" : {
    "quizElement" : "Quizelement",
    "quizNotification" : "Quizavisering",
    "viewAndCustomise" : "Visa och anpassa",
    "categoryAndScore" : "Kategori och poäng",
    "provideFeedback" : "Ge feedback",
    "addQuizElement" : "Lägg till quizelement",
    "typeOfBuilder" : "Quiz",
    "addQuestions" : "Lägg till frågor",
    "dragAndDropQuestion" : "Dra och släpp ett Fråga här.",
    "addNewPage" : "Lägg till Ny Sida",
    "editTemplate" : "Redigera Mall",
    "editResultPage" : "Redigera resultatsidan",
    "clonePage" : "Klona sida",
    "category" : {
      "category" : "Kategori",
      "watchVideo" : "Visa den här Video för att lära dig mer Om Hur Kategori påverkar resultaten Sida!",
      "useCategoryWhen" : "Använd Kategorier När",
      "manageCategories" : "Hantera Kategorier",
      "howItWorks" : "Hur fungerar det här 🤔",
      "howItWorks2" : "Hur fungerar det här",
      "addCategoryMessage" : "Lägg till en ny kategori",
      "assignCategoryMessage" : "Tilldela ett alternativ i Kategori till varje",
      "editResultsMessage" : "Visa Kategori-partitur in Resultat Sida",
      "addCategory" : "Lägg till Kategori",
      "deleteCategoryAlertMessage" : "Om du Raderar en Kategori resulterar du i vila av den Kategori in varje Alternativ",
      "editOrAddNewCategories" : "Du can Redigera Eller Inkludera Ny Kategorier",
      "toEvaluateTheResponder" : "Till Jämför baserade respondern På flera faktorer",
      "showMultipleCategoryScore" : "Visa multipla Kategori-partitur in Resultat Sida",
      "displayVaryingContent" : "Visning varierande Innehåll På resultaten Sida beroende På Poängnivån Kategori",
      "theOptionFieldIsRequired" : "Alternativfältet krävs",
      "addManage" : "Lägg till / Hantera",
      "enterCategoryPlaceholder" : "Ange namn på kategori",
      "carouselAlt" : "Förhandsgranskning av bild"
    },
    "quizSettings" : "Quizinställningar",
    "onQuizSubmission" : "Vid quizinlämning",
    "settings" : "Inställningar",
    "deletePage" : "Ta bort sida",
    "quizResult" : {
      "resultTemplate" : "Resultatmall",
      "quizResultAlertMessage" : "Den valda resultatsidan visas när quizet är klart",
      "overallScoreLabel" : "Totalpoäng"
    },
    "autoResponderSubheader": "Skicka ett automatiskt e-postmeddelande till personen som skickar in quizet (e-postmeddelandet innehåller en kopia av den information som de angav i quizet)",
    "sendSubmissionsAsPdf": "Skicka inlämnat quiz som en PDF",
    "sendQuizResultsAsPdf": "Skicka quizresultat som en PDF",
    "integrateHeader": "Integrera quiz",
    "integrateSubHeader": "Använd följande alternativ för att integrera ditt anpassade quiz på en webbplats",
    "integrateCopyLinkMessage": "Kopiera länken nedan och dela den enkelt var du vill.",
    "pageLabel": "Sida {n}",
    "pageName": "Sidnamn",
    "pagePosition": "Sidposition",
    "createContactOnPartialSubmissionSubText": "Skapar en kontakt när en användare klickar på ”Nästa” på en bild – även om hen inte slutför quizet.",
    "integratePopup": {
      "shareOrEmbed": "Bädda in eller dela quizet",
      "share": {
        "openFormLink": "Öppna Quiz- Länk"
      },
      "email" : {
        "emailSubheader" : "Skapa ett tomt E-inlägg och Inbäddad ditt quiz, Eller Välj en Mall och Inbäddad it Omelbart."
      }
    }
  },
  "textEditor": {
    "textAlign": "Textjustering",
    "list": "Lista",
    "sourceCode": "Källkod",
    "resetStyle": "Återställ stil",
    "resetDocumentStyle": "Återställ dokumentstil"
  }
}
